<script setup lang="ts">

const props = defineProps(["width"])

</script>

<template>
    <span :style="{'width': `${props.width}%`}" class="skeleton-box"></span>
</template>
      
<style>

@keyframes shimmer{
    100%{
      transform: translateX(100%);
    }
  }

.skeleton-box{
  display: inline-block;
  height: .8em;
  position: relative;
  overflow: hidden;
  background-color: #DDDBDD;
}

.skeleton-box::after{
    position: absolute;
    animation: shimmer 2s infinite;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 100%);
    content: '';
}


</style>